'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCssThemr = require('react-css-themr');

exports.default = _reactCssThemr.ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/theme-provider/lib/cjs/ThemeProvider.js
 ** module id = 281
 ** module chunks = 1
 **/